const zh = {
  header: {
    tip1:
      "为了防止系统误关闭您的虚拟空间中正在进行的游戏，导致您的游戏在未知情况下被掉线中断，需要您手动按照以下步骤完成设置。",
  },
  content: {
    list1: {
      title:
        "打开手机设置，搜索【后台高耗电】点击打开后台高耗电设置。选择虚拟大师，开启开关状态允许应用在后台运行。",
    },
    list2: {
      title:
        "多进程管理状态时，将虚拟大师添加【锁定】，保持后台可运行。-搜索【应用启动管理】",
    },
  },
};

export default zh;
